import OriginalCarImageIcon from "@/assets/illustrations/OriginalCarImageIcon.svg";

interface AllotmentCardProps {
    vrn: string;
    odo: number;
    soc: number;
    unitConsumption: number;
    totalFastChargingSessions: number;
    allowedCycles: number | null;
}

const AllotmentCard: React.FC<AllotmentCardProps> = ({ vrn, odo, soc, unitConsumption, totalFastChargingSessions, allowedCycles }) => {
  return (
    <div className="shadow-[0px_2px_0px_#3ebec8] rounded-[30px] box-border border-2 border-solid border-primary flex justify-center items-center py-4 bg-white">
      <div className="flex flex-col items-center ">
        <img src={OriginalCarImageIcon} className="w-60" />
        <div className="">
          <div className="flex flex-col items-center">
            <h5 className="text-secondary font-bold text-[20px] leading-[40px]">{vrn}</h5>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-4 w-full border-primary border-t-[1px] pt-[10px]">
          <div className="flex flex-col items-center justify-center ml-5">
            <p className="text-secondary text-[14px]">Odometer</p>
            <h5 className="text-primary font-semibold text-[20px]">{odo.toFixed(2)} KM</h5>
          </div>
          <div className="flex flex-col items-center justify-center mr-5">
            <p className="text-secondary text-[14px]">SOC</p>
            <h5 className="text-primary font-semibold text-[20px]">{soc}%</h5>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-4 mt-4 w-full border-primary border-t-[1px] pt-[10px]">
          <div className="flex flex-col items-center justify-center ml-5">
            <p className="text-[14px] text-center">Total DC Units Consumed</p>
            <h5 className="text-primary font-semibold text-[20px]">{unitConsumption} kWh</h5>
          </div>
          <div className="flex flex-col items-center justify-center mr-5">
            <p className="text-[14px] text-center">No. Of DC <br /> Sessions</p>
            <h5 className="text-primary font-semibold text-[20px]">{`${totalFastChargingSessions} ${allowedCycles !== null ? ` / ${allowedCycles}` : ""}`}</h5>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllotmentCard;
